module.exports = __webpack_public_path__ + "static/media/hack_7_bg.b03e78e0.jpg";